import {
  addGroup,
  addProfile,
  addSite,
  addUser,
  deleteGroup,
  deleteProfile,
  deleteSite,
  deleteUser,
  updateAuthentSettings,
  updateGroup,
  updateGroups,
  updateProfile,
  updateSite,
  updateUser,
  updateUsers,
} from '@redux/authent/authent.reducer';
import { addContact, addMessage, deleteContact, updateContact } from '@redux/chat/chat.reducer';
import {
  addGlobalScreenConfiguration,
  addGridConfiguration,
  addGridLayout,
  addInitializationMaskingZone,
  addNoFlyZone,
  addNoFlyZone3d,
  addNoInitZone,
  addNoNeutralizationZone,
  addOrganization,
  addPlatform,
  addPointOfInterest,
  addProcedureModel,
  addRoundConfiguration,
  addVideoStream,
  addZoneOfInterest,
  deleteGlobalScreenConfiguration,
  deleteGridConfiguration,
  deleteGridLayout,
  deleteInitializationMaskingZone,
  deleteNoFlyZone,
  deleteNoFlyZone3d,
  deleteNoInitZone,
  deleteNoNeutralizationZone,
  deleteOrganization,
  deletePlatform,
  deletePointOfInterest,
  deleteProcedureModel,
  deleteRoundConfiguration,
  deleteVideoStream,
  deleteZoneOfInterest,
  updateGlobalScreenConfiguration,
  updateGridConfiguration,
  updateGridLayout,
  updateHome,
  updateInitializationMaskingZone,
  updateMergingConfiguration,
  updateNoFlyZone,
  updateNoFlyZone3d,
  updateNoInitZone,
  updateNoNeutralizationZone,
  updateOrganization,
  updatePlatform,
  updatePointOfInterest,
  updateProcedureModel,
  updateRoundConfiguration,
  updateVideoConfiguration,
  updateVideoStream,
  updateZoneOfInterest,
} from '@redux/config/config.reducer';
import { deleteNotification, updateNotification, updateNotifications } from '@redux/data/data.reducer';
import { addLog, deleteLog, updateLog } from '@redux/global/global.reducer';
import { deleteFlight, deleteVertiport, upsertFlight, upsertVertiport } from '@redux/intercom/intercom.reducer';
import {
  addReplayEvent,
  addReplayManualPeriods,
  deleteReplayEvent,
  deleteReplayManualPeriods,
  replaceAllReplayEvents,
  updateReplayEvent,
  updateReplayManualPeriods,
  updateReplaySettings,
  updateReplayStorageConfiguration,
} from '@redux/replay/replay.reducer';
import {
  addEquipmentConfiguration,
  addPerimeterCamera,
  addSensor,
  deleteEquipmentConfiguration,
  deletePerimeterCamera,
  deleteSensor,
  updateEquipmentConfiguration,
  updatePerimeterCamera,
  updateSensor,
  updateSensorStorage,
} from '@redux/sensors/sensors.reducer';
import {
  addDrone,
  addFleet,
  addFlyRoute,
  addFlySection,
  addFlyZone,
  addPilot,
  addStrategicDrone,
  deleteDrone,
  deleteFleet,
  deleteFlyRoute,
  deleteFlySection,
  deleteFlyZone,
  deletePilot,
  deleteStrategicDrone,
  updateDrone,
  updateFleet,
  updateFlyRoute,
  updateFlySection,
  updateFlyZone,
  updatePilot,
  updateStrategicDrone,
} from '@redux/utm/utm.reducer';
import { ActionCreator } from '@reduxjs/toolkit';

export enum SseActionEnum {
  CREATE = 'CREATE',
  REPLACE_ALL = 'REPLACE-ALL',
  UPDATE = 'UPDATE',
  UPDATE_MULTIPLE = 'UPDATE-MULTIPLE',
  UPDATE_ALL = 'UPDATE-ALL',
  DELETE = 'DELETE',

  INIT = 'INIT',
  HEARTBEAT = 'HEARTBEAT',
  INFO = 'INFO',
  LOGOUT = 'LOGOUT',
  LOGOUT_MULTIPLE = 'LOGOUT-MULTIPLE',
}

export const CRUD_ACTION = [
  SseActionEnum.CREATE,
  SseActionEnum.REPLACE_ALL,
  SseActionEnum.UPDATE,
  SseActionEnum.UPDATE_MULTIPLE,
  SseActionEnum.UPDATE_ALL,
  SseActionEnum.DELETE,
] as const satisfies readonly SseActionEnum[];
export type CrudSseAction = (typeof CRUD_ACTION)[number];

export enum SseTypeEnum {
  //======GLOBAL=====\\
  LOG = 'LOG',
  //======AUTHENT=====\\
  PROFILE = 'PROFILE',
  SITE = 'SITE',
  USER = 'USER',
  AUTHENT_SETTINGS = 'AUTHENT_SETTINGS',
  GROUP = 'GROUP',
  //======CHAT======\\
  CONTACT = 'CONTACT',
  MSG = 'MSG',
  //======CONFIG======\\
  GRID_LAYOUT = 'GRID_LAYOUT',
  GRID_CONFIGURATION = 'GRID_CONFIGURATION',
  VIDEO_STREAM = 'VIDEO_STREAM',
  NIMBLE_CONFIGURATION = 'NIMBLE_CONFIGURATION',
  MERGING_CONFIGURATION = 'MERGING_CONFIGURATION',
  GLOBAL_SCREEN_CONFIGURATION = 'GLOBAL_SCREEN_CONFIGURATION',
  HOME = 'HOME',
  IMZ = 'IMZ',
  NFZ = 'NFZ',
  NFZ_3D = 'NFZ_3D',
  NIZ = 'NIZ',
  NNZ = 'NNZ',
  POI = 'POI',
  ZOI = 'ZOI',
  ROUND_CONFIGURATION = 'ROUND_CONFIGURATION',
  ORGANIZATION = 'ORGANIZATION',
  PLATFORM = 'PLATFORM',
  PROCEDURE_MODEL = 'PROCEDURE_MODEL',
  //======SENSOR======\\
  SENSOR_CONFIGURATION = 'SENSOR_CONFIGURATION',
  PERIMETER_CAMERA = 'PERIMETER_CAMERA',
  EQUIPMENT_CONFIGURATION = 'EQUIPMENT_CONFIGURATION',
  SENSOR_STORAGE = 'SENSOR_STORAGE',
  //========UTM=======\\
  PILOT = 'PILOT',
  DRONE = 'DRONE',
  FLEET = 'FLEET',
  STRATEGIC_DRONE = 'STRATEGIC_DRONE',
  DRONE_CLEARANCE = 'DRONE_CLEARANCE',
  FLIGHT_PLAN = 'FLIGHT_PLAN',
  FLY_ZONE = 'FLY_ZONE',
  FLY_ROUTE_SECTION = 'FLY_ROUTE_SECTION',
  FLY_ROUTE = 'FLY_ROUTE',
  //======REPLAY======\\
  REPLAY_EVENT = 'REPLAY_EVENT',
  REPLAY_PERIOD = 'REPLAY_PERIOD',
  REPLAY_STORAGE = 'REPLAY_STORAGE',
  REPLAY_SETTINGS = 'REPLAY_SETTINGS',
  //======DATA======\\
  NOTIFICATION = 'NOTIFICATION',
  //======INTERCOM======\\
  VERTIPORT = 'VERTIPORT',
  FLIGHT = 'FLIGHT',
}

export enum SseModuleTypeEnum {
  AUTHENT = 'AUTHENT',
  CHAT = 'CHAT',
  CONFIG = 'CONFIG',
  DATA = 'DATA',
  REPLAY = 'REPLAY',
  SENSOR = 'SENSOR',
  UTM = 'UTM',
  INTERCOM = 'INTERCOM',
  GLOBAL = 'GLOBAL',
}

export type ActionRecord = Partial<
  Record<Partial<Exclude<SseActionEnum, SseActionEnum.HEARTBEAT | SseActionEnum.INIT>>, ActionCreator<unknown> | null>
>;

export type ModelDataList<T> = {
  site: string;
  dataList: T[];
};

// Todo remove partial and move to constant file
export const ActionsMap: Record<SseTypeEnum, ActionRecord> = {
  //======GLOBAL=====\\
  [SseTypeEnum.LOG]: {
    [SseActionEnum.CREATE]: addLog,
    [SseActionEnum.UPDATE]: updateLog,
    [SseActionEnum.DELETE]: deleteLog,
  },
  //======AUTHENT=====\\
  [SseTypeEnum.PROFILE]: {
    [SseActionEnum.CREATE]: addProfile,
    [SseActionEnum.UPDATE]: updateProfile,
    [SseActionEnum.DELETE]: deleteProfile,
  },
  [SseTypeEnum.SITE]: {
    [SseActionEnum.CREATE]: addSite,
    [SseActionEnum.UPDATE]: updateSite,
    [SseActionEnum.DELETE]: deleteSite,
  },
  [SseTypeEnum.USER]: {
    [SseActionEnum.CREATE]: addUser,
    [SseActionEnum.UPDATE]: updateUser,
    [SseActionEnum.UPDATE_MULTIPLE]: updateUsers,
    [SseActionEnum.DELETE]: deleteUser,
  },
  [SseTypeEnum.AUTHENT_SETTINGS]: {
    [SseActionEnum.CREATE]: updateAuthentSettings,
    [SseActionEnum.UPDATE]: updateAuthentSettings,
    [SseActionEnum.DELETE]: updateAuthentSettings,
  },
  [SseTypeEnum.GROUP]: {
    [SseActionEnum.CREATE]: addGroup,
    [SseActionEnum.UPDATE]: updateGroup,
    [SseActionEnum.UPDATE_MULTIPLE]: updateGroups,
    [SseActionEnum.DELETE]: deleteGroup,
  },
  //========UTM=======\\
  [SseTypeEnum.PILOT]: {
    [SseActionEnum.CREATE]: addPilot,
    [SseActionEnum.UPDATE]: updatePilot,
    [SseActionEnum.DELETE]: deletePilot,
  },
  [SseTypeEnum.DRONE]: {
    [SseActionEnum.CREATE]: addDrone,
    [SseActionEnum.UPDATE]: updateDrone,
    [SseActionEnum.DELETE]: deleteDrone,
  },
  [SseTypeEnum.STRATEGIC_DRONE]: {
    [SseActionEnum.CREATE]: addStrategicDrone,
    [SseActionEnum.UPDATE]: updateStrategicDrone,
    [SseActionEnum.DELETE]: deleteStrategicDrone,
  },
  [SseTypeEnum.FLEET]: {
    [SseActionEnum.CREATE]: addFleet,
    [SseActionEnum.UPDATE]: updateFleet,
    [SseActionEnum.DELETE]: deleteFleet,
  },
  [SseTypeEnum.DRONE_CLEARANCE]: {
    [SseActionEnum.CREATE]: null,
    [SseActionEnum.UPDATE]: null,
    [SseActionEnum.DELETE]: null,
  },
  [SseTypeEnum.FLIGHT_PLAN]: {
    [SseActionEnum.CREATE]: null,
    [SseActionEnum.UPDATE]: null,
    [SseActionEnum.DELETE]: null,
  },
  [SseTypeEnum.FLY_ZONE]: {
    [SseActionEnum.CREATE]: addFlyZone,
    [SseActionEnum.UPDATE]: updateFlyZone,
    [SseActionEnum.DELETE]: deleteFlyZone,
  },
  [SseTypeEnum.FLY_ROUTE_SECTION]: {
    [SseActionEnum.CREATE]: addFlySection,
    [SseActionEnum.UPDATE]: updateFlySection,
    [SseActionEnum.DELETE]: deleteFlySection,
  },
  [SseTypeEnum.FLY_ROUTE]: {
    [SseActionEnum.CREATE]: addFlyRoute,
    [SseActionEnum.UPDATE]: updateFlyRoute,
    [SseActionEnum.DELETE]: deleteFlyRoute,
  },
  //=======SENSOR======\\
  [SseTypeEnum.SENSOR_CONFIGURATION]: {
    [SseActionEnum.CREATE]: addSensor,
    [SseActionEnum.UPDATE]: updateSensor,
    [SseActionEnum.DELETE]: deleteSensor,
  },
  [SseTypeEnum.PERIMETER_CAMERA]: {
    [SseActionEnum.CREATE]: addPerimeterCamera,
    [SseActionEnum.UPDATE]: updatePerimeterCamera,
    [SseActionEnum.DELETE]: deletePerimeterCamera,
  },
  [SseTypeEnum.EQUIPMENT_CONFIGURATION]: {
    [SseActionEnum.CREATE]: addEquipmentConfiguration,
    [SseActionEnum.UPDATE]: updateEquipmentConfiguration,
    [SseActionEnum.DELETE]: deleteEquipmentConfiguration,
  },
  [SseTypeEnum.SENSOR_STORAGE]: {
    [SseActionEnum.CREATE]: updateSensorStorage,
    [SseActionEnum.UPDATE]: updateSensorStorage,
    [SseActionEnum.DELETE]: updateSensorStorage,
  },
  //=======REPLAY======\\
  [SseTypeEnum.REPLAY_EVENT]: {
    [SseActionEnum.CREATE]: addReplayEvent,
    [SseActionEnum.REPLACE_ALL]: replaceAllReplayEvents,
    [SseActionEnum.UPDATE]: updateReplayEvent,
    [SseActionEnum.DELETE]: deleteReplayEvent,
  },
  [SseTypeEnum.REPLAY_PERIOD]: {
    [SseActionEnum.CREATE]: addReplayManualPeriods,
    [SseActionEnum.UPDATE]: updateReplayManualPeriods,
    [SseActionEnum.DELETE]: deleteReplayManualPeriods,
  },
  [SseTypeEnum.REPLAY_STORAGE]: {
    [SseActionEnum.CREATE]: updateReplayStorageConfiguration,
    [SseActionEnum.UPDATE]: updateReplayStorageConfiguration,
    [SseActionEnum.DELETE]: updateReplayStorageConfiguration,
  },
  [SseTypeEnum.REPLAY_SETTINGS]: {
    [SseActionEnum.UPDATE]: updateReplaySettings,
  },
  //=======CHAT======\\
  [SseTypeEnum.CONTACT]: {
    [SseActionEnum.CREATE]: addContact,
    [SseActionEnum.UPDATE]: updateContact,
    [SseActionEnum.DELETE]: deleteContact,
  },
  [SseTypeEnum.MSG]: {
    [SseActionEnum.CREATE]: addMessage,
  },
  //=======CONFIG======\\
  [SseTypeEnum.IMZ]: {
    [SseActionEnum.CREATE]: addInitializationMaskingZone,
    [SseActionEnum.UPDATE]: updateInitializationMaskingZone,
    [SseActionEnum.DELETE]: deleteInitializationMaskingZone,
  },
  [SseTypeEnum.NFZ]: {
    [SseActionEnum.CREATE]: addNoFlyZone,
    [SseActionEnum.UPDATE]: updateNoFlyZone,
    [SseActionEnum.DELETE]: deleteNoFlyZone,
  },
  [SseTypeEnum.NFZ_3D]: {
    [SseActionEnum.CREATE]: addNoFlyZone3d,
    [SseActionEnum.UPDATE]: updateNoFlyZone3d,
    [SseActionEnum.DELETE]: deleteNoFlyZone3d,
  },
  [SseTypeEnum.NIZ]: {
    [SseActionEnum.CREATE]: addNoInitZone,
    [SseActionEnum.UPDATE]: updateNoInitZone,
    [SseActionEnum.DELETE]: deleteNoInitZone,
  },
  [SseTypeEnum.NNZ]: {
    [SseActionEnum.CREATE]: addNoNeutralizationZone,
    [SseActionEnum.UPDATE]: updateNoNeutralizationZone,
    [SseActionEnum.DELETE]: deleteNoNeutralizationZone,
  },
  [SseTypeEnum.ZOI]: {
    [SseActionEnum.CREATE]: addZoneOfInterest,
    [SseActionEnum.UPDATE]: updateZoneOfInterest,
    [SseActionEnum.DELETE]: deleteZoneOfInterest,
  },
  [SseTypeEnum.POI]: {
    [SseActionEnum.CREATE]: addPointOfInterest,
    [SseActionEnum.UPDATE]: updatePointOfInterest,
    [SseActionEnum.DELETE]: deletePointOfInterest,
  },
  [SseTypeEnum.GRID_LAYOUT]: {
    [SseActionEnum.CREATE]: addGridLayout,
    [SseActionEnum.UPDATE]: updateGridLayout,
    [SseActionEnum.DELETE]: deleteGridLayout,
  },
  [SseTypeEnum.GRID_CONFIGURATION]: {
    [SseActionEnum.CREATE]: addGridConfiguration,
    [SseActionEnum.UPDATE]: updateGridConfiguration,
    [SseActionEnum.DELETE]: deleteGridConfiguration,
  },
  [SseTypeEnum.VIDEO_STREAM]: {
    [SseActionEnum.CREATE]: addVideoStream,
    [SseActionEnum.UPDATE]: updateVideoStream,
    [SseActionEnum.DELETE]: deleteVideoStream,
  },
  [SseTypeEnum.ROUND_CONFIGURATION]: {
    [SseActionEnum.CREATE]: addRoundConfiguration,
    [SseActionEnum.UPDATE]: updateRoundConfiguration,
    [SseActionEnum.DELETE]: deleteRoundConfiguration,
  },
  [SseTypeEnum.HOME]: {
    [SseActionEnum.UPDATE]: updateHome,
  },
  [SseTypeEnum.MERGING_CONFIGURATION]: {
    [SseActionEnum.UPDATE]: updateMergingConfiguration,
  },
  [SseTypeEnum.GLOBAL_SCREEN_CONFIGURATION]: {
    [SseActionEnum.CREATE]: addGlobalScreenConfiguration,
    [SseActionEnum.UPDATE]: updateGlobalScreenConfiguration,
    [SseActionEnum.DELETE]: deleteGlobalScreenConfiguration,
  },
  [SseTypeEnum.NIMBLE_CONFIGURATION]: {
    [SseActionEnum.UPDATE]: updateVideoConfiguration,
  },
  [SseTypeEnum.ORGANIZATION]: {
    [SseActionEnum.CREATE]: addOrganization,
    [SseActionEnum.UPDATE]: updateOrganization,
    [SseActionEnum.DELETE]: deleteOrganization,
  },
  [SseTypeEnum.PLATFORM]: {
    [SseActionEnum.CREATE]: addPlatform,
    [SseActionEnum.UPDATE]: updatePlatform,
    [SseActionEnum.DELETE]: deletePlatform,
  },
  //=======DATA=======\\
  [SseTypeEnum.NOTIFICATION]: {
    [SseActionEnum.UPDATE]: updateNotification,
    [SseActionEnum.UPDATE_ALL]: updateNotifications,
    [SseActionEnum.DELETE]: deleteNotification,
  },
  [SseTypeEnum.PROCEDURE_MODEL]: {
    [SseActionEnum.CREATE]: addProcedureModel,
    [SseActionEnum.UPDATE]: updateProcedureModel,
    [SseActionEnum.DELETE]: deleteProcedureModel,
  },
  //=======INTERCOM=======\\
  [SseTypeEnum.VERTIPORT]: {
    [SseActionEnum.CREATE]: upsertVertiport,
    [SseActionEnum.UPDATE]: upsertVertiport,
    [SseActionEnum.DELETE]: deleteVertiport,
  },
  [SseTypeEnum.FLIGHT]: {
    [SseActionEnum.CREATE]: upsertFlight,
    [SseActionEnum.UPDATE]: upsertFlight,
    [SseActionEnum.DELETE]: deleteFlight,
  },
};

export interface SseMessageEvent {
  data: string;
  comment: string;
  lastEventId: string;
}
